<template>
  <back v-if="appId === 'wxfcb34416b1538017'"></back>
  <div class="wrapper">
    <!-- 头部 -->
    <van-sticky>
      <div class="head flexbox_row">
        <!-- 下拉选择 -->
        <van-dropdown-menu class="type" active-color="#FF2F2F">
          <van-dropdown-item v-model="classifyId" :options="columns" @change="getColumnGoods" />
        </van-dropdown-menu>
        <!-- 搜索框 -->
        <form action="/" class="flex1 flexbox_column_center">
          <van-search v-model="searchVal" class="search-inp" shape="round" background="transparent"
            placeholder="搜索你想要的商品" @focus="onFocus">
            <template #left-icon>
              <div class="flexbox_column_center wh100pre pright32">
                <van-icon :size="20" :name="require('@/assets/images/mall/search.png')" />
              </div>
            </template>
          </van-search>
        </form>
      </div>
      <van-tabs v-model:active="subColumnCode" title-active-color="#ff2f2f" color="#ff2f2f" background="#f9f9f9"
        @change="switchTab" v-if="subColumnList.length">
        <van-tab v-for="item in subColumnList" :key="item.id" :title="item.columnName" :name="item.columnIds"></van-tab>
      </van-tabs>
    </van-sticky>
    <!-- 主体 -->
    <div class="main">
      <van-pull-refresh v-if="columnGoods.length" v-model="refreshing" @refresh="onRefresh">
        <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了~" :immediate-check="false"
          @load="onLoad()">
          <div class="grid flex_row_space-between"
            data-masonry='{ "itemSelector": ".grid-item",fit-width="true",horizontal-order="true",gutter=10}'>
            <div class="grid-item flexbox_column f28" v-for="item in columnGoods" :key="item.id"
              @click="toGoodsDetail(item)">
              <img class="box-img" v-lazy="item.imageUrl" alt="" />
              <div class="box-info flexbox_column flex_between">
                <span class="line2Hide">{{ item.spuName }}</span>
                <div class="flex_row_space-between">
                  <div>
                    <span class="f40 colorOne">
                      <i style="font-style: normal" class="f28">￥</i>
                      <span v-html="$handlePrice(item.cardlanPrice)"></span>
                    </span>
                    <span style="text-decoration: line-through" class="f24 colorTwo">
                      ¥{{ item.originalPrice }}
                    </span>
                  </div>
                  <span class="f24 colorTwo">已售{{ item.salesVolume }}</span>
                </div>

                <div class="tips integral flexbox_row_center mtop16" v-if="item.qrcodeSubsidyAmount">
                  <img src="@/assets/images/points-mall/payment.png" class="icon mleft16 mright10" />
                  赠{{ getMoneyFenToYuan(item.qrcodeSubsidyAmount) }}元消费券
                </div>

                <div class="tips integral flexbox_row_center mtop10">
                  <img src="@/assets/images/points-mall/jifen-icon1.png" class="icon mleft16 mright10" />
                  赠<span v-html="$handlePrice(item.cardlanPrice)"></span>积分
                </div>

                <!-- <div class="tips integral flexbox_row_center mtop16" v-if="item.cashSubsidyAmount">
                  <img src="@/assets/images/points-mall/jifen-icon1.png" class="icon mleft16 mright10" />
                  赠<span v-html="getMoneyFenToYuan(item.cashSubsidyAmount)"></span>元餐饮券
                </div> -->

                <div v-if="distUserInfo.vipCode === '10' || !distUserInfo.vipCode">
                  <div class="tips integral flexbox_row_center mtop16" v-if="item.pointsValue">
                    <img src="@/assets/images/points-mall/jifen-icon1.png" class="icon mleft16 mright10" />
                    {{ item.pointsValue }}绿色积分可抵{{
                      handlePointsExchangeMoney(item)
                    }}元
                  </div>
                </div>
                <div class="tips vipSuper mtop16 flexbox_row_center" v-else>
                  <img src="@/assets/images/member/vipSuper.png" class="icon mleft16" />
                  <span class="mleft8">会员特价:</span>
                  <i style="font-style: normal" class="f20">￥</i>
                  <span class="f32" v-html="handleVipPrice(item)"></span>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
      <empty :type="20" v-if="isEmpty"></empty>
    </div>
  </div>
</template>
<script>
import {
  getGoodsPage,
  getColumnListApi,
  getColumnDetailApi,
} from '@/utils/mall'
import { getStorage, getAppIdStorage, setAppIdStorage } from '@/libs/storage'
import { resetLabel, deepCopy, unifyNumber, cutImgMethod } from '@/libs/tools'
import { openStatus } from '@/utils/api'
import { norepeat } from '@/libs/gcontrol'
import { mapState, mapActions } from 'vuex'
import back from '@/components/back'
import empty from '@/components/empty'
import imagesloaded from 'imagesloaded'
import Masonry from 'masonry-layout'
export default {
  name: 'mallClassify',
  components: {
    empty,
    back,
  },
  data() {
    return {
      loading: false,
      refreshing: false,
      finished: false,
      noFirst: false,
      curPage: 1,
      size: 10,
      total: 0,
      searchVal: '',
      classifyId: '',
      appId: '',
      infos_storage: null,
      environment: null,
      columns: [],
      columnGoods: [],
      requestIng: false,
      btnFlag: false,
      scrollY: '',
      isEmpty: false,
      columnCode: '',
      subColumnList: [],
      subColumnCode: '',
      code: '', //接收乘车码巴士商城传过来得code
    }
  },
  computed: {
    ...mapState(['cachedViews', 'distUserInfo']),
    handlePointsExchangeMoney() {
      return (e) => {
        return unifyNumber(e.pointsExchangeMoney * e.pointsValue)
      }
    },
    getMoneyFenToYuan() {
      return (money) => {
        if (money) {
          return unifyNumber(money / 100)
        }
        return 0
      }
    },
    handleVipPrice() {
      return (e) => {
        let priceHtml = ''
        priceHtml = this.$handlePrice(
          e.productMode === 2 ? e?.vipEquityPrice : e?.vipPriceList[0].vipPrice
        )
        return priceHtml
      }
    },
  },
  async mounted() {
    this.appId = getStorage('appId')
    this.environment = getStorage('environment')
    this.infos_storage = getAppIdStorage(this.appId) || {}

    this.classifyId = this.$route.query.id || ''
    this.columnCode = this.$route.query.columnCode || ''
    this.code = this.$route.query.code || ''
    console.log(this.classifyId, 'this.classifyId')
    if (this.appId === 'wxfcb34416b1538017') {
      //土特产小程序分类页面
      await this.getColumnDetail()
    } else {
      await this.getColumnList()
    }
    //获取商品列表数据
    this.getColumnGoods(this.classifyId)

    //获取用户分销状态（会员状态）
    if (!this.distUserInfo) {
      this.getOpenStatus()
    }
    console.log('mounted=========>')
  },
  updated() {
    let grid = document.querySelector('.grid')
    if (grid) {
      let msnry = new Masonry(grid, {
        itemSelector: '.grid-item',
        fitWidth: 'true',
        horizontalOrder: 'true',
        gutter: 10,
      })
      imagesloaded('.grid-item', () => {
        msnry.layout() // 图片加载完成后重新绘制。
      })
    }
  },
  beforeRouteLeave(to, form, next) {
    if (to.path === '/mall/goods-detail') {
      this.$store.commit('cachedViews', [...this.cachedViews, 'mallClassify'])
    } else {
      let newArr = norepeat(this.cachedViews)
      newArr.forEach((item, index) => {
        if (item === 'mallClassify') {
          newArr.splice(index, 1)
        }
      })
      this.$store.commit('cachedViews', newArr)
    }
    next()
  },

  methods: {
    onFocus() {
      if (this.appId === 'wxfcb34416b1538017') {
        this.$router.push({
          path: '/search',
          query: {
            type: 'isLocal',
          },
        })
      } else {
        this.$router.push('/search')
      }
    },
    // 跳转到商品详情页
    toGoodsDetail(data) {
      this.infos_storage.commodityName = data.productName
      setAppIdStorage(this.appId, this.infos_storage)
      this.$router.push({
        path: '/mall/goods-detail',
        query: { id: data.id },
      })
    },
    async getOpenStatus() {
      const RES = await openStatus()
      const { data, code } = RES.data
      if (code === 200) {
        this.infos_storage.distUserInfo = data
        this.$store.commit('distUserInfo', this.infos_storage.distUserInfo)
      }
    },
    async getColumnDetail() {
      const RES = await getColumnDetailApi('speciality')
      const { data, code } = RES.data
      if (code === 200) {
        this.columnCode = data.columnCode
        await this.getColumnList(data.id)
      }
    },
    async getColumnList(parentId) {
      try {
        let params = {
          businessCode: this.infos_storage.mercode,
        }
        if (parentId) {
          params.parentId = parentId
        }
        const RES = await getColumnListApi(params)
        const { data, code } = RES.data
        if (code === 200) {
          this.columns = deepCopy(data)
          resetLabel(this.columns, 'columnName', 'text')
          resetLabel(this.columns, 'columnIds', 'value')
          this.columns.unshift({ text: '全部', value: '' })
          //匹配巴士商城传过来得code对应的classifyId
          this.classifyId = this.columns.filter((item) => {
            return item.columnCode === this.code
          })[0].value
        }
      } catch (error) {
        console.log('getColumnListApi接口异常捕获', error)
      }
    },

    switchTab(e) {
      this.finished = false
      this.loading = true
      this.curPage = 1
      this.total = 0
      this.refreshing = false
      this.getGoodsData()
    },
    // 根据分类ID获取商品
    getColumnGoods(id) {
      //有二级分类需要展示出来tab栏
      this.subColumnList = []
      this.columns.forEach((item) => {
        if (
          id &&
          id === item.value &&
          item.subColumnList &&
          item.subColumnList.length
        ) {
          //防止改到原数组
          this.subColumnList = deepCopy(item.subColumnList)

          //全部 查询的就是子分类的数据
          let columnCode = this.columns.find(
            (item) => item.value === this.classifyId
          ).columnCode
          this.subColumnList.unshift({
            columnCode: columnCode,
            columnIds: this.classifyId,
            columnName: '全部',
          })
        }
      })

      if (this.subColumnList.length) {
        this.subColumnCode = this.subColumnList[0].columnIds
      } else {
        this.subColumnCode = ''
      }

      window.scrollTo(0, 0)
      this.columnGoods = []
      this.curPage = 1
      this.finished = false
      this.loading = true
      this.getGoodsData()
    },
    onLoad() {
      if (this.requestIng) {
        return
      }
      this.curPage++
      this.refreshing = false
      this.finished = false
      this.getGoodsData()
    },
    onRefresh() {
      // 还原列表相关状态
      this.finished = false
      this.loading = true
      this.curPage = 1
      this.total = 0
      this.refreshing = false
      this.getGoodsData()
    },

    //有带subColumnCode参数是查找二级分类商品列表（土特产分类）
    async getGoodsData() {
      try {
        this.isEmpty = false
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0,
        })

        // 防止上拉加载触发
        this.requestIng = true

        let params = {
          page: this.curPage,
          size: this.size,
          columnIds: this.subColumnCode || this.classifyId,
        }

        //当选择全部分类时
        if (!this.classifyId) {
          if (this.appId === 'wxfcb34416b1538017') {
            params.columnCode = 'speciality'
          } else {
            params.columnCode = 'all'
          }
        } else {
          if (this.subColumnCode) {
            params.columnCode = this.subColumnList.find(
              (item) => item.columnIds === this.subColumnCode
            ).columnCode
          } else {
            console.log('this.columns', this.columns)
            this.columnCode = this.columns.find(
              (item) => item.value === this.classifyId
            ).columnCode
            params.columnCode = this.columnCode
          }
        }

        const RES = await getGoodsPage(params)
        this.requestIng = false
        this.loading = false
        this.$toast.clear()
        const { data, msg, code } = RES.data
        if (code === 200) {
          data.list.forEach(async (item) => {
            if (item.provider === 30) {
              item.imageUrl = `${item.imageUrl}?w=334&h=334`
            } else {
              item.imageUrl = cutImgMethod(item.imageUrl, 334, 334)
            }
          })
          if (this.curPage === 1) {
            this.columnGoods = [...data.list]
          } else {
            this.columnGoods = [...this.columnGoods, ...data.list]
          }

          this.total = data.total
          // 如果是页数和每页所含订单数 大于或等于 订单总数 则结束列表请求
          const isLast = this.curPage * this.size >= this.total
          if (isLast) {
            this.finished = true
          }
        } else {
          this.$toast(msg)
        }
        if (!this.columnGoods.length) this.isEmpty = true
      } catch (error) {
        console.log('getGoodsPage接口异常捕获', error)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.colorOne {
  color: #ff2f2f;
}

.colorTwo {
  color: #989898;
}

.colorThr {
  color: #282828;
}

.wrapper {
  background-color: #f9f9f9;
  padding-bottom: 50px;
  height: 100vh;

  .head {
    // position: fixed;
    // left: 0;
    // top: 0;
    width: 100%;
    z-index: 99;
    background-color: #fff;

    .type {
      ::v-deep(.van-dropdown-menu__bar) {
        box-shadow: none;
      }
    }

    .search-inp {
      padding: 0 16px;
      width: 100%;

      .van-cell {
        line-height: 20px;
      }

      ::v-deep(.van-search__field) {
        background-color: #f9f9f9;
        border-radius: 17px;
      }
    }
  }

  .main {
    padding-top: 16px;
    padding-bottom: 100px;

    .grid {
      // display: grid;
      // width: 100%;
      // grid-template-columns: repeat(2, 1fr);
      // gap: 10px;
      margin: 0 16px;
      flex-wrap: wrap;

      .grid-item {
        margin-bottom: 8px;

        .box-img {
          width: 167px;
          height: 167px;
          border-radius: 10px 10px 0 0;
        }

        .box-info {
          padding: 8px 8px 16px 8px;
          background-color: #fff;
          border-radius: 0 0 10px 10px;
          // height: 92px;
          width: 167px;
          box-sizing: border-box;

          .title {
            height: 40px;
            max-height: 40px;
            font-size: 14px;
            font-weight: 500;
            color: #282828;
          }

          .tips {
            width: 150px;
            height: 24px;
            padding-left: 4px;
            border-radius: 12px;
            font-weight: 400;
            font-size: 12px;
            line-height: 24px;

            .icon {
              width: 16px;
              height: 16px;
            }
          }

          .integral {
            background: #fff5e6;
            color: #ff2b23;
          }

          .vipHigh {
            background: linear-gradient(300deg,
                #d9992c 0%,
                #fedf4e 0%,
                #fec44c 100%);
            color: #333333;
          }

          .vipSuper {
            background: linear-gradient(134deg, #322d34 0%, #726b69 100%);
            color: #f7bb87;
          }
        }
      }
    }
  }
}
</style>
